import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-81dfc7c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "换回须知：", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", null, "1、"), /*#__PURE__*/_createElementVNode("span", null, "由于系统故障，十二生肖纸上生花合成项目合成金色马、金色羊生肖产生错位，您可以选择换回正确的金色马或金色羊生肖")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", null, "2、"), /*#__PURE__*/_createElementVNode("span", null, "换回操作后，您将不再拥有当前的金色生肖")]), /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("i", null, "3、"), /*#__PURE__*/_createElementVNode("span", null, "换回操作之前，此链接永久有效")])], -1));
const _hoisted_4 = {
  class: "link-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "open-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.change && $options.change(...args))
  }, "藏品换回")])])]);
}